import { render, staticRenderFns } from "./SeoScores.vue?vue&type=template&id=b149213a&scoped=true&"
import script from "./SeoScores.vue?vue&type=script&lang=js&"
export * from "./SeoScores.vue?vue&type=script&lang=js&"
import style0 from "./SeoScores.vue?vue&type=style&index=0&id=b149213a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b149213a",
  null
  
)

/* custom blocks */
import block0 from "./SeoScores.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports